import React from "react";
import { Form, Input, Row, Col } from "antd";

const SymptomForm = () => {
  return (
    <Row className="gx-d-flex gx-flex-row">
      <Col xl={24} lg={24} md={24} sm={24} xs={24}>
        <Form.Item
          name="symptomName"
          label="Symptom Name"
          rules={[
            {
              required: true,
              message: "Pleas enter the Symptom name!",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default SymptomForm;
